const wowApp = require('angular').module('wowApp.shop');

wowApp.service('UnsubscribeEdmService', ['Restangular', 'AtmService', require('./unsubscribe-edm-service')]);

wowApp.directive('wowUnsubscribeEdm', ['UnsubscribeEdmService', 'SettingsService', '$state', '$sce', '$log', require('./unsubscribe-edm-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/unsubscribeedm/index.js
 **/